import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { FamilyStatus } from '@mekimix/shared/dist/types/Family';


export interface CurrentFamilyState {
  newFamilyname: string;
  newPhone: string;
  newEmail: string;
  newStatus: FamilyStatus;
  newNumOfPeople: number;
  newMentor: string;
}

const initialState: CurrentFamilyState = {
  newFamilyname: "",
  newPhone: "",
  newEmail: "",
  newStatus: FamilyStatus.OK,
  newNumOfPeople: 0,
  newMentor: "",
};

const currentFamilySlice = createSlice({
  name: 'currentFamily',
  initialState,
  reducers: {
    setNewFamilyname: (state, action: PayloadAction<string>) => {
      state.newFamilyname = action.payload;
    },
    setNewPhone: (state, action: PayloadAction<string>) => {
      state.newPhone = action.payload;
    },
    setNewEmail: (state, action: PayloadAction<string>) => {
      state.newEmail = action.payload;
    },
    setNewStatus: (state, action: PayloadAction<FamilyStatus>) => {
      state.newStatus = action.payload;
    },
    setNewNumOfPeople: (state, action: PayloadAction<number>) => {
      state.newNumOfPeople = action.payload;
    },
    setNewMentor: (state, action: PayloadAction<string>) => {
      state.newMentor = action.payload;
    },
    fillForm: (state, action: PayloadAction<CurrentFamilyState>) => {
      state.newFamilyname=action.payload.newFamilyname;
      state.newEmail=action.payload.newEmail;
      state.newPhone=action.payload.newPhone;
      state.newNumOfPeople=action.payload.newNumOfPeople;
      state.newStatus=action.payload.newStatus;
      state.newMentor=action.payload.newMentor;
    },
    resetForm: (state) => {
      state.newFamilyname = '';
      state.newEmail = '';
      state.newStatus = FamilyStatus.OK;
      state.newNumOfPeople = 0;
      state.newMentor = '';
    },
  },
});

export const {
setNewFamilyname,
  setNewPhone,
  setNewEmail,
  setNewStatus,
  setNewNumOfPeople,
  setNewMentor,
  fillForm,
  resetForm,
} = currentFamilySlice.actions;

export default currentFamilySlice.reducer;

export const selectCurrentFamily = (state: RootState) =>
  state.currentFamily ?? Object;
